import React, { useState } from "react";
import Category from "../components/Category/ProductsByCategory"
import ProductPopup from "../components/ProductPopup/ProductPopup";
const ListProduct = () => {
  // const [showPopup, setShowPopup] = useState(false);

  return (


    <>
      {/* <div>
      <button onClick={() => setShowPopup(true)}>Afficher le produit</button>

      {showPopup && <ProductPopup />}

      {showPopup && (
        <div onClick={() => setShowPopup(false)} style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 999
        }} />
      )}
    </div>
  ; */}
      <Category />
    </>
  );
}
export default ListProduct;